import React from 'react';

export const App: React.FC = () => <div>Theatre Garden в розробці</div>;
